import React from 'react';

import { mapProductToTrackingProduct } from '../../../content/blocks/productCarouselRecommendations/mapProductToTrackingProduct';
import { trackCarouselNavigation } from '../../../tracking/common/carousel';
import { trackProductClick, trackProductImpression } from '../../../tracking/common/products';
import { TrackingContext } from '../../../types/TrackingContext';
import {
  ProductCarouselRecommendations,
  ProductCarouselRecommendationsProps,
} from '../../organisms/ProductCarouselRecommendations';
import { BlockContainer } from '../BlockContainer';
import * as styles from './ProductCarouselRecommendationsBlock.style';

export interface ProductCarouselRecommendationsBlockProps
  extends ProductCarouselRecommendationsProps {
  trackingTitle: string;
  trackingPosition?: number;
  hasDisabledCookies: boolean;
}

export const ProductCarouselRecommendationsBlock = ({
  trackingPosition,
  placementType,
  currency,
  ...restOfProps
}: ProductCarouselRecommendationsBlockProps) => {
  const trackingContext: Omit<TrackingContext, 'trackingTitle'> = {
    trackingContentType: 'Rich Relevance',
    trackingPosition,
  };

  return (
    <BlockContainer wrapperStyles={styles.wrapper} maxWidth="max" columnsXL={10}>
      <ProductCarouselRecommendations
        currency={currency}
        placementType={placementType}
        onVisible={({ products, strategy }) => {
          trackProductImpression({
            ...trackingContext,
            products: products.map((product) => mapProductToTrackingProduct(product, currency)),
            trackingTitle: `${strategy} : ${placementType}`,
          });
        }}
        onNavigateCarousel={(swiped, control, { numberOfItems, strategy }) => {
          const trackingDirection = control === 'next' ? 'next' : 'previous';

          trackCarouselNavigation(swiped, trackingDirection, {
            ...trackingContext,
            numberOfItems,
            trackingTitle: `${strategy} : ${placementType}`,
          });
        }}
        onProductClick={(
          e,
          { product, index, numberOfItems, strategy, recommendationsTrackingUrl },
        ) => {
          trackProductClick(e, {
            ...trackingContext,
            recommendationsTrackingUrl,
            product: mapProductToTrackingProduct(product, currency),
            productIndex: index,
            numberOfItems,
            trackingTitle: `${strategy} : ${placementType}`,
          });
        }}
        {...restOfProps}
      />
    </BlockContainer>
  );
};

export type { ProductCarouselRecommendationsProps };
